import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { AccountSettingsComponent } from './account-settings.component';
import { PodSponsorsComponent } from './components/pod-sponsors/pod-sponsors.component';
import { PodSponsorModalComponent } from './components/pod-sponsor-modal/pod-sponsor-modal.component';
import { ConfirmationModalComponent } from './components/confirmation-modal/confirmation-modal.component';
import { UserNotificationSettingsComponent } from './components/user-notification-settings/user-notification-settings.component';


@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild([
      { path: 'account-settings', component: AccountSettingsComponent }
    ]),
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModule,
    BrowserAnimationsModule,
  ],
  entryComponents: [PodSponsorModalComponent],
  declarations: [AccountSettingsComponent, PodSponsorsComponent, PodSponsorModalComponent, UserNotificationSettingsComponent, ConfirmationModalComponent],
})
export class AccountSettingsModule { }
